/**
 * @format
 */
import { api } from '@/scripts/api';

export const AccountCurrencyConfigurationService = {
    get(accountId) {
        const service = `/ms/exchange-rates/v1/account-configuration/${accountId}`;
        return new Promise((resolve, reject) => {
            api.get(service).then(resolve).catch(reject);
        });
    },

    post(accountId, payload) {
        const service = `/ms/exchange-rates/v1/account-configuration/${accountId}`;
        return new Promise((resolve, reject) => {
            api.post(service, payload).then(resolve).catch(reject);
        });
    },
};
